import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';



const CONTENT_ITEMS = [
    {
        title: { ko: '3D와 2D 페인팅 동시 지원', en: 'Seamless 3D & 2D Texture Painting' },
        description: {
        ko: '3D 및 2D 에디터를 모두 지원하여 사용자가 텍스처를 쉽고 빠르게 편집할 수 있도록 설계되었습니다. 직관적인 인터페이스와 강력한 기능을 제공하여 효율적인 작업이 가능합니다.',
        en: 'Edit textures effortlessly with both 3D and 2D painting modes. Designed for an intuitive workflow, combining a user-friendly  interface with powerful features for efficient texturing.'
        },
        video: "m3u8/pt_01.m3u8",
        thum: require("../../assets/thumnails/pt_01_thum.webp"),
        reverse: false
    },
    {
        title: { ko: '레이어 기반 페인팅', en: 'Layer-Based Painting' },
        description: {
        ko: '레이어를 활용하여 색상, 텍스처, 효과를 계층적으로 적용할 수 있어 높은 유연성과 효율성을 제공합니다. 또한 UModeler X는 타블렛을 지원하여 보다 자연스럽고 정밀한 편집이 가능합니다.',
        en: 'Apply colors, textures, and effects  in layers for seamless blending and efficient editing.  UModeler X also supports graphics tablet input, enabling natural and precise brush strokes.'},
        video: "m3u8/pt_02.m3u8",
        thum: require("../../assets/thumnails/pt_02_thum.webp"),
        reverse: true
    },
    {
        title: { ko: '마스킹과 스티커', en: 'Masking & sticker' },
        description: {
        ko: '마스킹과 스티커 기능을 활용하면 번거로운 레이어 편집을 손쉽게 해결할 수 있습니다. 특정 영역을 정밀하게 조정하고, 원하는 디자인 요소를 간편하게 추가하여 더욱 효과적인 작업이 가능합니다.',
        en: 'Easily refine layer edits with masking and stickers.  Precisely adjust specific areas and add design  elements effortlessly for a more efficient workflow.'
        },
        video: "m3u8/pt_03.m3u8",
        thum: require("../../assets/thumnails/pt_03_thum.webp"),
        reverse: false
    },
    {
        title: { ko: '노멀 페인팅', en: 'Real-Time Normal Painting' },
        description: {
        ko: '브러시 도구를 사용하면 표면의 굴곡과 질감을 실시간으로 표현할 수 있어 더욱 자연스럽고 사실적인 효과를 연출할 수 있습니다. 다양한 브러시 옵션을 통해 세밀한 디테일까지 손쉽게 조정할 수 있습니다.',
        en: 'Use brush tools to paint surface depth and texture in real time,  achieving natural and realistic effects.  Fine-tune details effortlessly with various brush options.'
        },
        video: "m3u8/pt_04.m3u8",
        thum: require("../../assets/thumnails/pt_04_thum.webp"),
        reverse: true
    }
];

export default function Painting() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    
    return (
        <>
            <div className="main_back">
                <div className="main_part padding">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? '페인팅' : 'Painting'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? '3D 모델 위에 자유롭게 텍스처를 그려보세요.' : 'Paint textures freely—directly on 3D models or in a 2D unwrapped view.'}
                        </span>
                    </div>

                    {/* 콘텐츠 섹션 */}
                    <div className="header_page_content_box">
                        {CONTENT_ITEMS.map((item, index) => {
                        return (
                            <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                            {item.reverse ? (
                                <>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>
                                </>
                            ) : (
                                <>
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                </>
                            )}
                            </div>
                        );
                        })}
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    그림 그리듯 부드러운 텍스처링
                                </>
                                :
                                <>
                                    Smooth & Natural Texture Painting
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 써보기' : 'Try for Free'}
                            </button>
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '문의하기' : 'Contact Us'}
                            </button>
                        </div>
                    </div>
                </div>
                
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
